import { useDevice } from 'platform/foundation-tw';

/**
 * Returns true when the viewport width is within the tablet range (768–1024 px).
 *
 * Used alongside `useIsMobileView` to drive layout switches that apply to both
 * mobile and tablet. The check covers mobile || tablet so callers should use
 * `isMobile || isTablet` for "mobile-or-tablet".
 */
export function useIsTabletView() {
  const device = useDevice();
  return device === "mobile" || device === "tablet";
}